import { useEffect } from "react";
import { useUser } from "context/UserContext";
import Loader from "components/Loader";
import { useNavigate, useLocation } from "react-router-dom";

const SignIn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated, loading } = useUser();

  useEffect(() => {
    const handleLogin = async () => {
      try {
        await login();
      } catch (error) {
        console.error("Login error:", error);
        alert(`Login failed: ${error.message || "Unknown error"}`);
      }
    };
    const performNavigation = async () => {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      if (!loading) {
        if (isAuthenticated) {
          // Check if we have a stored redirect URL in sessionStorage (for new tabs)
          const storedRedirectUrl = sessionStorage.getItem('wso2_redirect_url');
          // Priority: URL redirect param > stored redirect > state from > home
          let targetUrl = storedRedirectUrl || "/home";
          console.log("🔍 DEBUG - Final redirect to:", targetUrl);
          navigate(targetUrl, { replace: true });
        } else {
          handleLogin();
        }
      }
    };
    performNavigation();
  }, [isAuthenticated, loading, login, navigate, location.state]);

  return (
    <div>
      <Loader />
    </div>
  );
};

export default SignIn;
